import React from 'react'
import styles from './styles.module.css'

export const CartIcon = ({number,color=null,styles=null,width=null}) => {
  return (
    <div style={styles?styles:{}}>
      <svg width={width? width:"24"} height={width?width:"24"} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 2.52802V0.0190159C0.072 0.0140159 0.141 0.0050159 0.21 0.0050159C1.378 0.0040159 2.546 0.0070159 3.714 1.58954e-05C3.863 -0.000984105 3.938 0.0450159 4.001 0.190016C4.311 0.902016 4.641 1.60502 4.949 2.31802C5.024 2.49102 5.114 2.54102 5.29 2.54102C11.09 2.53502 16.89 2.53602 22.69 2.53702C23.367 2.53702 23.839 2.91202 23.972 3.55102C24.036 3.85302 23.988 4.14102 23.849 4.40702C22.412 7.16202 20.983 9.92202 19.529 12.667C19.075 13.523 18.332 13.932 17.401 13.933C14.521 13.936 11.641 13.937 8.761 13.929C8.574 13.929 8.479 13.988 8.393 14.159C8.112 14.727 7.813 15.285 7.521 15.848C7.304 16.266 7.415 16.467 7.862 16.467H21.581V18.987C21.512 18.991 21.442 18.999 21.373 18.999C16.669 18.999 11.965 19.001 7.261 18.999C5.821 18.997 4.743 17.827 4.799 16.337C4.816 15.907 4.947 15.513 5.144 15.138C5.636 14.202 6.124 13.262 6.618 12.328C6.65218 12.2728 6.67137 12.2096 6.67365 12.1447C6.67593 12.0798 6.66123 12.0155 6.631 11.958C5.24509 8.88226 3.86342 5.80459 2.486 2.72502C2.422 2.58402 2.349 2.53002 2.198 2.53202C1.518 2.54202 0.838 2.53602 0.158 2.53602C0.11 2.53602 0.064 2.53102 0 2.52802ZM7.502 19C8.16481 19.0019 8.79986 19.2663 9.26807 19.7355C9.73628 20.2046 9.99947 20.8402 10 21.503C9.99788 22.1656 9.73331 22.8004 9.26419 23.2684C8.79507 23.7364 8.15964 23.9995 7.497 24C6.83438 23.9984 6.19942 23.7342 5.73134 23.2651C5.26326 22.7961 5.00026 22.1606 5 21.498C5.00132 20.8352 5.26548 20.2 5.73452 19.7317C6.20357 19.2634 6.8392 19.0003 7.502 19ZM22 21.502C21.9979 22.1646 21.7335 22.7993 21.2646 23.2674C20.7957 23.7356 20.1606 23.999 19.498 24C18.8352 23.9987 18.2 23.7345 17.7317 23.2655C17.2634 22.7964 17.0003 22.1608 17 21.498C17.0013 20.8352 17.2655 20.2 17.7345 19.7317C18.2036 19.2634 18.8392 19.0003 19.502 19C20.1646 19.0021 20.7993 19.2665 21.2674 19.7354C21.7356 20.2043 21.9989 20.8395 22 21.502Z" fill={color ? color:"white"}/>
        <text fill="black"  fontFamily="Gotham" fontSize="10" fontWeight="bold" letterSpacing="0em"  x="13" y="11.5" textAnchor="middle">{number}</text>
      </svg>
    </div>
  )
}

export const Star = ({width=null, height=null, fill = true, stroke=null, color=null, key=0})=>{
  return(
    <svg xmlns="http://www.w3.org/2000/svg" width={width||17} height={height||17} viewBox="0 0 24 24"><path d="M12 .587l3.668 7.568 8.332 1.151-6.064 5.828 1.48 8.279-7.416-3.967-7.417 3.967 1.481-8.279-6.064-5.828 8.332-1.151z" fill={fill ? color||'#e6bf69' : '#fff'} stroke={color||'#e6bf69'} key={key}/></svg>
  )
}

export const StarGroup = ({width=null, height=null, stroke=null, color=null, star=0, async=true})=>{
  let array = [];
  star = Math.round(star);
  if(!async){
    if(star != 5){
      for(let i= 1; i<=(5-star);i++){
        array.push({width,height,fill:false,stroke,color})
      }
    }
  }
  for(let i= 1; i<=star;i++){
    array.push({width,height,fill:true,stroke,color})
  }
  if(async){
    if(star != 5){
      for(let i= 1; i<=(5-star);i++){
        array.push({width,height,fill:false,stroke,color})
      }
    }
  }
  return(
    <>
      {array.map((star,index)=>(
          <>
          <Star width={star.width} height={star.height} fill={star.fill} stroke={star.stroke} color={star.color} key={index}/>
          </>
        )
      )}
    </>
  )
}

export const SearchIcon = () => {
  return (
    <div className={styles.logoContainer}>
      <svg
        aria-hidden="true"
        focusable="false"
        role="presentation"
        className={styles.searchLogo}
        viewBox="0 0 37 40"
        fill="#FFF"
      >
        <path d="M35.6 36l-9.8-9.8c4.1-5.4 3.6-13.2-1.3-18.1-5.4-5.4-14.2-5.4-19.7 0-5.4 5.4-5.4 14.2 0 19.7 2.6 2.6 6.1 4.1 9.8 4.1 3 0 5.9-1 8.3-2.8l9.8 9.8c.4.4.9.6 1.4.6s1-.2 1.4-.6c.9-.9.9-2.1.1-2.9zm-20.9-8.2c-2.6 0-5.1-1-7-2.9-3.9-3.9-3.9-10.1 0-14C9.6 9 12.2 8 14.7 8s5.1 1 7 2.9c3.9 3.9 3.9 10.1 0 14-1.9 1.9-4.4 2.9-7 2.9z"></path>
      </svg>
    </div>
  )
}

export const SearchIconInverted = () => {
  return (
   
      <svg
        aria-hidden="true"
        focusable="false"
        role="presentation"
        className={styles.searchLogo}
        viewBox="0 0 37 40"
        fill="#000"
      >
        <path d="M35.6 36l-9.8-9.8c4.1-5.4 3.6-13.2-1.3-18.1-5.4-5.4-14.2-5.4-19.7 0-5.4 5.4-5.4 14.2 0 19.7 2.6 2.6 6.1 4.1 9.8 4.1 3 0 5.9-1 8.3-2.8l9.8 9.8c.4.4.9.6 1.4.6s1-.2 1.4-.6c.9-.9.9-2.1.1-2.9zm-20.9-8.2c-2.6 0-5.1-1-7-2.9-3.9-3.9-3.9-10.1 0-14C9.6 9 12.2 8 14.7 8s5.1 1 7 2.9c3.9 3.9 3.9 10.1 0 14-1.9 1.9-4.4 2.9-7 2.9z"></path>
      </svg>
  
  )
}

export const ExitIcon = () => {
  return (
    <svg aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 40 40">
      <path
        d="M23.868 20.015L39.117 4.78c1.11-1.108 1.11-2.77 0-3.877-1.109-1.108-2.773-1.108-3.882 0L19.986 16.137 4.737.904C3.628-.204 1.965-.204.856.904c-1.11 1.108-1.11 2.77 0 3.877l15.249 15.234L.855 35.248c-1.108 1.108-1.108 2.77 0 3.877.555.554 1.248.831 1.942.831s1.386-.277 1.94-.83l15.25-15.234 15.248 15.233c.555.554 1.248.831 1.941.831s1.387-.277 1.941-.83c1.11-1.109 1.11-2.77 0-3.878L23.868 20.015z"
        className="layer"
      ></path>
    </svg>
  )
}

export const InfoIcon = () => {
  return (
    <svg width="19px" height="19px" viewBox="0 0 19 19" xmlns="http://www.w3.org/2000/svg">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-1011.000000, -819.000000)" fill="#575757" fillRule="nonzero">
          <g transform="translate(1011.000000, 819.000000)">
            <path d="M9.49959788,0 C4.2535873,0 0,4.2535873 0,9.49959788 C0,14.7456085 4.2535873,19 9.49959788,19 C14.7456085,19 19,14.7456085 19,9.49959788 C19,4.2535873 14.7456085,0 9.49959788,0 Z M11.4772063,14.7230899 C10.9882328,14.9161058 10.5989841,15.0624762 10.3070476,15.1638095 C10.0159153,15.2651429 9.67733333,15.3158095 9.29210582,15.3158095 C8.70019048,15.3158095 8.23936508,15.1710476 7.9112381,14.882328 C7.58311111,14.5936085 7.41985185,14.2276825 7.41985185,13.7829418 C7.41985185,13.6100317 7.43191534,13.4331005 7.45604233,13.2529524 C7.48097354,13.0728042 7.52038095,12.8701376 7.57426455,12.6425397 L8.18628571,10.4807619 C8.24016931,10.2732698 8.28681481,10.0762328 8.32380952,9.89286772 C8.36080423,9.70789418 8.37849735,9.53820106 8.37849735,9.38378836 C8.37849735,9.10874074 8.32139683,8.91572487 8.208,8.80715344 C8.09299471,8.69858201 7.87665608,8.64550265 7.55415873,8.64550265 C7.3965291,8.64550265 7.23407407,8.6688254 7.06759788,8.7178836 C6.90273016,8.76855026 6.75957672,8.81439153 6.64215873,8.85942857 L6.80380952,8.19352381 C7.20431746,8.03026455 7.58793651,7.89032804 7.95386243,7.77451852 C8.31978836,7.65710053 8.66560847,7.59919577 8.99132275,7.59919577 C9.57921693,7.59919577 10.0328042,7.74234921 10.3520847,8.02543915 C10.6697566,8.30933333 10.8297989,8.67847619 10.8297989,9.13206349 C10.8297989,9.22615873 10.8185397,9.39183069 10.7968254,9.62827513 C10.7751111,9.86552381 10.7340952,10.0818624 10.674582,10.2805079 L10.0657778,12.4358519 C10.0159153,12.6087619 9.97168254,12.8066032 9.9314709,13.0277672 C9.89206349,13.2489312 9.8727619,13.4178201 9.8727619,13.5312169 C9.8727619,13.8175238 9.9362963,14.0129524 10.0649735,14.1166984 C10.1920423,14.2204444 10.4148148,14.2727196 10.7300741,14.2727196 C10.8788571,14.2727196 11.0453333,14.2461799 11.2335238,14.194709 C11.4201058,14.1432381 11.5552169,14.0973968 11.6404656,14.0579894 L11.4772063,14.7230899 Z M11.3694392,5.9746455 C11.085545,6.23843386 10.743746,6.37032804 10.3440423,6.37032804 C9.94514286,6.37032804 9.60093122,6.23843386 9.31462434,5.9746455 C9.02992593,5.71085714 8.88596825,5.38996825 8.88596825,5.01519577 C8.88596825,4.64122751 9.03073016,4.31953439 9.31462434,4.05333333 C9.60093122,3.78632804 9.94514286,3.65362963 10.3440423,3.65362963 C10.743746,3.65362963 11.0863492,3.78632804 11.3694392,4.05333333 C11.6533333,4.31953439 11.7956825,4.64122751 11.7956825,5.01519577 C11.7956825,5.39077249 11.6533333,5.71085714 11.3694392,5.9746455 Z"></path>
          </g>
        </g>
      </g>
    </svg>
  )
}


export const BrunoIcon = () => {
  return (
    <svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M4.67769 15.4516L8.08378 9.00069L4.68526 2.56223L13.9182 2.56154L10.5141 9L13.9182 15.4516H4.67769ZM21.4948 8.99723C22.5455 8.16508 23.1339 6.90162 23.1339 5.436C23.1339 3.49823 22.3597 2.03885 21.0868 1.13262C20.0133 0.378 18.6144 0 16.7669 0L0 0.0103846L5.28872 9L0 18L16.7669 17.9931C18.6144 17.9931 20.0126 17.6158 21.0868 16.8612C22.3597 15.9556 23.1339 14.4955 23.1339 12.5578C23.1339 11.0922 22.5455 9.82869 21.4948 8.99723Z" fill="black"/>
    </svg>    
  )
}

export const BlogHamburger = ({topRef, middleRef, bottomRef}) =>{
  return(
    <svg width="38" height="25" viewBox="0 0 38 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line  ref={topRef} y1="1.5" x2="38" y2="1.5" stroke="black" stroke-width="3"/>
    <line ref={middleRef} y1="12.5" x2="38" y2="12.5" stroke="black" stroke-width="3"/>
    <line ref={bottomRef} y1="23.5" x2="38" y2="23.5" stroke="black" stroke-width="3"/>
    </svg>
  )
}


export const ShopifySecureBadge = ({ highlightRef }) => {
  return (
    <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="100" height="100" />
      <g id="shopify-secure-badge">
        <g id="type">
          <path
            id="Fill-1"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M50 0.427C22.665 0.427 0.427 22.665 0.427 50C0.427 77.335 22.665 99.573 50 99.573C77.334 99.573 99.573 77.335 99.573 50C99.573 22.665 77.333 0.427 50 0.427ZM50 100C22.43 100 0 77.57 0 50C0 22.43 22.43 0 50 0C77.57 0 100 22.43 100 50C100 77.57 77.57 100 50 100Z"
            fill="white"
          />
          <path
            id="Fill-4"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M50 14.166C30.24 14.166 14.166 30.241 14.166 50C14.166 69.76 30.241 85.834 50 85.834C69.758 85.834 85.833 69.759 85.833 50C85.833 30.241 69.758 14.166 50 14.166ZM50 86.474C29.888 86.474 13.526 70.112 13.526 50C13.526 29.888 29.888 13.526 50 13.526C70.111 13.526 86.473 29.888 86.473 50C86.473 70.112 70.11 86.474 50 86.474Z"
            fill="white"
          />
          <path
            id="Fill-7"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M19.571 20.801L19.561 20.79C19.4673 20.6953 19.3933 20.5831 19.343 20.4598C19.2927 20.3365 19.2672 20.2045 19.268 20.0713C19.2687 19.9382 19.2957 19.8065 19.3473 19.6837C19.399 19.561 19.4743 19.4496 19.569 19.356C19.7587 19.1654 20.0164 19.0581 20.2853 19.0575C20.5543 19.0569 20.8124 19.1632 21.003 19.353L21.013 19.363C21.409 19.76 21.403 20.403 21.006 20.798C20.608 21.193 19.966 21.198 19.571 20.801Z"
            fill="white"
          />
          <path
            id="Fill-9"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M24.23 16.613L24.223 16.602C24.1445 16.4945 24.088 16.3725 24.0567 16.2432C24.0254 16.1138 24.0199 15.9795 24.0405 15.848C24.0612 15.7165 24.1075 15.5903 24.1769 15.4768C24.2463 15.3632 24.3374 15.2644 24.445 15.186C24.6611 15.0264 24.9317 14.9592 25.1974 14.9989C25.463 15.0386 25.7021 15.1822 25.862 15.398L25.87 15.41C26.0279 15.6272 26.0932 15.8981 26.0516 16.1634C26.01 16.4287 25.8648 16.6666 25.648 16.825C25.4319 16.9846 25.1613 17.0519 24.8957 17.0121C24.63 16.9724 24.3909 16.8288 24.231 16.613"
            fill="white"
          />
          <path
            id="Fill-11"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M29.4179 13.186L29.4119 13.174C29.2875 12.9357 29.2628 12.6577 29.3432 12.4011C29.4237 12.1446 29.6027 11.9305 29.8409 11.806C30.0785 11.6801 30.3563 11.6537 30.6133 11.7324C30.8703 11.8112 31.0856 11.9887 31.2119 12.226L31.2189 12.239C31.4789 12.734 31.2839 13.345 30.7889 13.607C30.2929 13.867 29.6789 13.682 29.4179 13.186Z"
            fill="white"
          />
          <path
            id="Fill-13"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M35.22 12.286L35.571 11.381C36.093 11.581 36.591 11.6509 37.11 11.477C37.517 11.339 37.709 11.094 37.62 10.83L37.616 10.816C37.531 10.564 37.332 10.486 36.509 10.548C35.517 10.622 34.844 10.567 34.541 9.66795L34.537 9.65495C34.259 8.83195 34.737 8.06595 35.663 7.75495C36.2704 7.53973 36.9339 7.54326 37.539 7.76495L37.274 8.68895C36.78 8.54595 36.328 8.51095 35.946 8.63995C35.564 8.76795 35.422 9.01095 35.496 9.22995L35.5 9.24395C35.601 9.54095 35.827 9.57295 36.679 9.50995C37.677 9.43995 38.306 9.59695 38.573 10.386L38.578 10.399C38.881 11.299 38.364 12.035 37.386 12.363C36.7 12.593 35.927 12.588 35.22 12.286Z"
            fill="white"
          />
          <path
            id="Fill-15"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M39.094 6.76596L40.125 6.55596L40.505 8.40896L42.405 8.01896L42.025 6.16496L43.057 5.95496L44.016 10.639L42.986 10.849L42.6 8.96896L40.7 9.35896L41.085 11.239L40.055 11.45L39.094 6.76596Z"
            fill="white"
          />
          <path
            id="Fill-17"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M48.9069 7.856V7.842C48.8569 7.025 48.2169 6.381 47.3729 6.432C46.5289 6.483 45.9829 7.185 46.0329 8.003V8.016C46.0829 8.833 46.7229 9.478 47.5669 9.427C48.4109 9.375 48.9569 8.673 48.9069 7.857V7.856ZM44.9369 8.096V8.082C44.8549 6.728 45.8569 5.552 47.3279 5.463C48.7979 5.375 49.9199 6.407 50.0019 7.763V7.777C50.0859 9.131 49.0819 10.305 47.6119 10.395C46.1419 10.484 45.0199 9.45 44.9379 8.096"
            fill="white"
          />
          <path
            id="Fill-19"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M53.275 7.99198C53.798 8.02998 54.127 7.73898 54.156 7.33098L54.158 7.31698C54.192 6.84698 53.883 6.57198 53.359 6.53398L52.548 6.47598L52.444 7.93298L53.274 7.99198H53.275ZM51.568 5.45398L53.516 5.59398C54.651 5.67598 55.291 6.39998 55.221 7.37198V7.38598C55.142 8.48998 54.241 8.99998 53.174 8.92298L52.377 8.86498L52.274 10.295L51.226 10.22L51.568 5.45398Z"
            fill="white"
          />
          <path
            id="Fill-21"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M56.798 5.974L57.834 6.148L57.049 10.861L56.011 10.688L56.798 5.974Z"
            fill="white"
          />
          <path
            id="Fill-23"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M59.5979 6.46698L63.1199 7.37998L62.8799 8.30498L60.3759 7.65698L60.1199 8.64098L62.3269 9.21298L62.0869 10.139L59.8799 9.56698L59.4149 11.357L58.3979 11.093L59.5979 6.46698Z"
            fill="white"
          />
          <path
            id="Fill-25"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M64.812 11.068L64.17 7.70398L65.312 8.15598L65.665 10.357L67.45 9.00198L68.56 9.44198L65.796 11.437L65.095 13.206L64.118 12.82L64.812 11.068Z"
            fill="white"
          />
          <path
            id="Fill-27"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M70.891 13.369L70.899 13.357C71.189 12.879 71.811 12.73 72.292 13.02C72.769 13.31 72.929 13.932 72.638 14.411L72.631 14.423C72.341 14.902 71.717 15.05 71.237 14.76C71.007 14.6213 70.8414 14.3971 70.7766 14.1365C70.7117 13.8759 70.7528 13.6003 70.891 13.37"
            fill="white"
          />
          <path
            id="Fill-29"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M76.063 16.8529L76.071 16.8429C76.2429 16.6359 76.49 16.5055 76.758 16.4806C77.0259 16.4556 77.2928 16.5381 77.5 16.7099C77.93 17.0669 77.998 17.7049 77.642 18.1379L77.633 18.1479C77.461 18.3548 77.2139 18.485 76.946 18.5099C76.6781 18.5349 76.4113 18.4525 76.204 18.2809C75.9962 18.1101 75.8647 17.8638 75.8383 17.5961C75.8119 17.3284 75.8927 17.0612 76.063 16.8529Z"
            fill="white"
          />
          <path
            id="Fill-31"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M80.664 21.052L80.674 21.043C80.8743 20.864 81.1374 20.7719 81.4056 20.7869C81.6737 20.8019 81.9249 20.9228 82.104 21.123C82.1933 21.2214 82.2624 21.3366 82.3072 21.4617C82.3521 21.5869 82.3718 21.7197 82.3653 21.8525C82.3588 21.9853 82.3262 22.1155 82.2694 22.2357C82.2125 22.3559 82.1325 22.4637 82.034 22.553L82.024 22.563C81.8235 22.7414 81.5605 22.8332 81.2925 22.8182C81.0245 22.8032 80.7733 22.6827 80.594 22.483C80.4137 22.2838 80.3199 22.0213 80.333 21.753C80.3461 21.4847 80.4652 21.2326 80.664 21.052Z"
            fill="white"
          />
          <path
            id="Fill-33"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M18.294 77.7789L18.304 77.769C18.5025 77.5875 18.7648 77.4922 19.0335 77.504C19.3022 77.5158 19.5552 77.6337 19.737 77.832C20.117 78.244 20.097 78.886 19.684 79.267L19.674 79.277C19.4754 79.4582 19.2131 79.5533 18.9445 79.5415C18.6759 79.5297 18.4229 79.4119 18.241 79.214C18.0579 79.0166 17.9606 78.7546 17.9705 78.4855C17.9805 78.2164 18.0968 77.9623 18.294 77.7789Z"
            fill="white"
          />
          <path
            id="Fill-35"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M23.296 82.613L23.304 82.602C23.647 82.161 24.285 82.086 24.726 82.429C25.169 82.773 25.253 83.409 24.91 83.85L24.901 83.862C24.558 84.302 23.921 84.378 23.479 84.035C23.3735 83.9537 23.2851 83.8524 23.2188 83.7369C23.1525 83.6214 23.1096 83.494 23.0926 83.3619C23.0756 83.2299 23.0848 83.0957 23.1197 82.9672C23.1546 82.8387 23.2145 82.7183 23.296 82.613Z"
            fill="white"
          />
          <path
            id="Fill-37"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M28.988 86.535L28.994 86.523C29.0583 86.4061 29.1449 86.3031 29.249 86.2198C29.3531 86.1364 29.4726 86.0744 29.6007 86.0373C29.7287 86.0001 29.8629 85.9886 29.9954 86.0033C30.1279 86.018 30.2562 86.0586 30.373 86.123C30.864 86.39 31.05 87.004 30.783 87.497L30.776 87.509C30.508 88 29.891 88.178 29.399 87.909C29.2818 87.8458 29.1782 87.7601 29.0941 87.6568C29.0101 87.5535 28.9472 87.4346 28.9091 87.307C28.871 87.1794 28.8585 87.0455 28.8722 86.913C28.8859 86.7806 28.9256 86.6521 28.989 86.535"
            fill="white"
          />
          <path
            id="Fill-39"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M34.406 91.021L35.23 90.511C35.527 90.984 35.884 91.34 36.402 91.511C36.812 91.647 37.112 91.567 37.2 91.301L37.204 91.288C37.288 91.036 37.175 90.854 36.482 90.407C35.644 89.87 35.138 89.422 35.439 88.521L35.443 88.508C35.717 87.684 36.558 87.359 37.485 87.667C38.147 87.887 38.642 88.282 38.98 88.804L38.21 89.384C37.903 88.972 37.562 88.672 37.18 88.546C36.797 88.418 36.539 88.526 36.465 88.746L36.46 88.76C36.362 89.058 36.523 89.22 37.241 89.681C38.081 90.227 38.491 90.729 38.228 91.521L38.224 91.534C37.924 92.434 37.07 92.712 36.092 92.388C35.3812 92.1548 34.7811 91.6682 34.406 91.021Z"
            fill="white"
          />
          <path
            id="Fill-41"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M40.835 88.732L44.373 89.412L44.196 90.33L41.684 89.848L41.499 90.798L43.711 91.224L43.536 92.142L41.324 91.717L41.134 92.702L43.681 93.192L43.504 94.109L39.934 93.423L40.835 88.732Z"
            fill="white"
          />
          <path
            id="Fill-43"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M45.745 92.004V91.989C45.813 90.634 46.891 89.573 48.356 89.646C49.256 89.691 49.78 90.018 50.2 90.476L49.495 91.213C49.143 90.86 48.778 90.637 48.301 90.615C47.497 90.575 46.884 91.214 46.844 92.031L46.842 92.045C46.802 92.862 47.334 93.573 48.152 93.615C48.697 93.641 49.042 93.439 49.434 93.118L50.069 93.825C49.551 94.326 48.989 94.625 48.07 94.58C46.665 94.51 45.676 93.374 45.745 92.004Z"
            fill="white"
          />
          <path
            id="Fill-45"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M52.0339 92.486L51.7679 89.766L52.8149 89.664L53.0779 92.357C53.1539 93.132 53.5799 93.495 54.2189 93.431C54.8589 93.37 55.2089 92.945 55.1339 92.189L54.8679 89.464L55.9149 89.361L56.1769 92.046C56.3179 93.487 55.5779 94.274 54.2999 94.399C53.0209 94.524 52.1699 93.887 52.0339 92.486Z"
            fill="white"
          />
          <path
            id="Fill-47"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M60.311 90.787C60.809 90.664 61.029 90.329 60.933 89.937L60.929 89.923C60.822 89.487 60.459 89.336 59.963 89.458L58.947 89.708L59.277 91.043L60.311 90.787ZM57.697 89.038L59.822 88.514C60.412 88.369 60.91 88.422 61.292 88.652C61.614 88.847 61.843 89.178 61.952 89.615L61.955 89.629C62.14 90.379 61.852 90.949 61.315 91.315L62.859 92.694L61.665 92.988L60.301 91.748L60.289 91.751L59.499 91.945L59.867 93.433L58.844 93.684L57.697 89.038Z"
            fill="white"
          />
          <path
            id="Fill-49"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M63.17 87.548L66.519 86.215L66.864 87.083L64.487 88.03L64.845 88.931L66.938 88.097L67.283 88.966L65.191 89.8L65.562 90.732L67.972 89.772L68.318 90.642L64.938 91.987L63.17 87.548Z"
            fill="white"
          />
          <path
            id="Fill-51"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M71.547 86.23L71.541 86.218C71.244 85.744 71.391 85.118 71.865 84.822C71.9775 84.7508 72.103 84.7025 72.2342 84.6798C72.3654 84.6571 72.4998 84.6605 72.6297 84.6897C72.7596 84.719 72.8825 84.7735 72.9913 84.8503C73.1001 84.927 73.1928 85.0244 73.264 85.137L73.271 85.149C73.569 85.622 73.421 86.248 72.947 86.545C72.473 86.843 71.847 86.705 71.547 86.23Z"
            fill="white"
          />
          <path
            id="Fill-53"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M77.225 82.186L77.216 82.176C77.1279 82.0763 77.0604 81.9602 77.0172 81.8343C76.974 81.7085 76.956 81.5754 76.9643 81.4426C76.9726 81.3098 77.0069 81.1799 77.0654 81.0604C77.1238 80.9409 77.2053 80.834 77.305 80.746C77.404 80.6571 77.5195 80.5887 77.645 80.5445C77.7704 80.5003 77.9034 80.4813 78.0362 80.4886C78.169 80.4958 78.2991 80.5292 78.419 80.5867C78.5389 80.6443 78.6463 80.7249 78.735 80.824L78.744 80.834C79.117 81.252 79.074 81.893 78.656 82.266C78.4556 82.445 78.1923 82.5371 77.924 82.5221C77.6556 82.5071 77.4042 82.3862 77.225 82.186Z"
            fill="white"
          />
          <path
            id="Fill-55"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M82.142 77.27L82.132 77.261C81.696 76.911 81.632 76.272 81.982 75.836C82.334 75.401 82.972 75.328 83.406 75.678L83.418 75.688C83.854 76.038 83.917 76.677 83.565 77.111C83.215 77.547 82.577 77.621 82.142 77.27Z"
            fill="white"
          />
        </g>
        <g id="shopify-secure-badge-white">
          <path
            id="Shape"
            d="M62.433 36.246C62.4198 36.1655 62.3801 36.0917 62.3201 36.0364C62.2601 35.9811 62.1833 35.9475 62.102 35.941C61.965 35.929 59.28 35.888 59.28 35.888C59.28 35.888 57.035 33.718 56.814 33.496C56.592 33.276 56.158 33.342 55.99 33.392L54.861 33.74C54.7213 33.2845 54.5406 32.8427 54.321 32.42C53.522 30.9 52.351 30.098 50.937 30.095H50.932C50.834 30.095 50.735 30.105 50.637 30.113C50.596 30.063 50.553 30.013 50.51 29.965C49.894 29.31 49.103 28.989 48.157 29.018C46.33 29.07 44.511 30.384 43.035 32.718C41.997 34.358 41.207 36.422 40.983 38.019L37.386 39.127C36.326 39.459 36.294 39.49 36.156 40.484C36.053 41.237 33.283 62.568 33.283 62.568L56.501 66.566L66.566 64.076C66.566 64.076 62.46 36.436 62.434 36.246H62.433ZM53.699 34.099L51.899 34.654C51.884 33.733 51.775 32.452 51.344 31.345C52.729 31.605 53.412 33.168 53.699 34.099ZM50.682 35.029L46.807 36.224C47.18 34.796 47.891 33.374 48.764 32.442C49.088 32.095 49.542 31.708 50.08 31.487C50.586 32.537 50.695 34.023 50.682 35.03V35.029ZM48.194 30.229C48.622 30.219 48.984 30.313 49.292 30.515C48.7601 30.7987 48.2803 31.1707 47.873 31.615C46.713 32.855 45.823 34.778 45.469 36.635L42.285 37.617C42.913 34.696 45.373 30.31 48.193 30.229H48.194Z"
            fill="#503A8B"
          />
          <path
            id="side"
            d="M62.024 35.876C61.067 35.855 60.11 35.836 59.154 35.824C59.154 35.824 56.869 33.648 56.644 33.426C56.5554 33.3458 56.4437 33.2957 56.325 33.283L56.327 66.566L66.566 64.074C66.566 64.074 62.388 36.374 62.362 36.182C62.3483 36.1002 62.3075 36.0253 62.2462 35.9695C62.1849 35.9136 62.1067 35.88 62.024 35.874V35.877V35.876Z"
            fill="#1F1244"
          />
          <g id="sheen-mask">
            <mask
              id="mask0_108_2980"
              style={{ maskType: 'alpha' }}
              maskUnits="userSpaceOnUse"
              x="33"
              y="29"
              width="34"
              height="38"
            >
              <g id="mask-4">
                <path
                  id="Vector1"
                  d="M48.157 29.018C49.103 28.989 49.894 29.31 50.51 29.965L50.637 30.113L50.785 30.101L50.932 30.095C52.352 30.098 53.522 30.901 54.321 32.419C54.486 32.736 54.629 33.065 54.749 33.401L54.861 33.741L55.99 33.392C56.063 33.37 56.189 33.345 56.325 33.342V33.283C56.411 33.293 56.494 33.322 56.566 33.367C56.66 33.389 56.746 33.429 56.814 33.497L59.216 35.827L60.62 35.847L62.024 35.877C62.0733 35.8795 62.1216 35.8922 62.1658 35.9142C62.21 35.9363 62.2492 35.9672 62.281 36.005C62.34 36.046 62.387 36.105 62.413 36.174L62.434 36.257L66.566 64.077L56.501 66.567L56.398 66.548L56.327 66.566L56.326 66.536L33.283 62.568L36.156 40.486L36.215 40.1C36.3 39.623 36.413 39.473 36.865 39.302L37.098 39.221L37.386 39.129L40.983 38.02C41.207 36.423 41.997 34.36 43.035 32.717C44.511 30.384 46.33 29.07 48.157 29.017V29.018Z"
                  fill="white"
                />
              </g>
            </mask>
            <g mask="url(#mask0_108_2980)">
              <path
                id="highlight"
                ref={highlightRef}
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M22 14H44V82H22V14Z"
                fill="url(#paint0_linear_108_2980)"
              />
            </g>
          </g>
          <path
            id="Path_0"
            d="M50.35 41.363L49.219 45.776C49.219 45.776 47.957 45.177 46.459 45.276C44.265 45.422 44.241 46.865 44.265 47.225C44.384 49.199 49.367 49.63 49.646 54.253C49.866 57.89 47.794 60.378 44.811 60.575C41.229 60.81 39.257 58.608 39.257 58.608L40.016 55.244C40.016 55.244 42 56.804 43.589 56.699C44.627 56.631 44.997 55.753 44.961 55.129C44.804 52.555 40.747 52.707 40.492 48.477C40.275 44.917 42.518 41.31 47.468 40.985C49.375 40.856 50.351 41.363 50.351 41.363H50.35Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_108_2980"
          x1="43.4988"
          y1="45.8723"
          x2="22"
          y2="45.8723"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#EEEEEE" stop-opacity="0" />
          <stop offset="0.50077" stop-color="#FFFEFE" stop-opacity="0.586" />
          <stop offset="1" stop-color="white" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export const GuaranteeBadge = ({ arrowRef }) => {
  return (
    <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="30-day-money-back-guarantee-badge 1">
        <g id="svg/badge/30-day-money-back-guarantee-badge">
          <g id="two-tone">
            <path
              id="Oval"
              d="M50 73C62.7025 73 73 62.7025 73 50C73 37.2975 62.7025 27 50 27C37.2975 27 27 37.2975 27 50C27 62.7025 37.2975 73 50 73Z"
              fill="#1F1244"
            />
            <path
              id="Combined-Shape"
              fillrule="evenodd"
              clipRule="evenodd"
              d="M47.6336 73.0016C35.041 71.6781 25.9061 60.3974 27.2298 47.8038C28.5533 35.2111 39.8351 26.0754 52.4277 27.3989L47.6336 73.0016Z"
              fill="#483285"
            />
          </g>
          <g id="positive-elements">
            <g id="lines">
              <g id="Group-3">
                <mask
                  id="mask0_159_3238"
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="100"
                  height="100"
                >
                  <g id="mask-2">
                    <path id="Vector2" d="M0 0H100V100H0V0Z" fill="white" />
                  </g>
                </mask>
                <g mask="url(#mask0_159_3238)">
                  <path
                    id="Fill-01"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M50 0.427C22.665 0.427 0.427 22.665 0.427 50C0.427 77.335 22.665 99.573 50 99.573C77.334 99.573 99.573 77.335 99.573 50C99.573 22.665 77.334 0.427 50 0.427ZM50 100C22.43 100 0 77.57 0 50C0 22.43 22.43 0 50 0C77.57 0 100 22.43 100 50C100 77.57 77.57 100 50 100Z"
                    fill="white"
                  />
                </g>
              </g>
              <path
                id="Fill-04"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M50 14.166C30.24 14.166 14.166 30.241 14.166 50C14.166 69.76 30.241 85.834 50 85.834C69.759 85.834 85.834 69.759 85.834 50C85.834 30.241 69.759 14.166 50 14.166V14.166ZM50 86.474C29.888 86.474 13.526 70.112 13.526 50C13.526 29.888 29.888 13.526 50 13.526C70.111 13.526 86.474 29.888 86.474 50C86.474 70.112 70.11 86.474 50 86.474Z"
                fill="white"
              />
              <path
                id="Fill-06"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M54.106 56.36C54.106 54.049 52.408 53 50.292 52.006L49.512 60.231H49.902C52.102 60.231 54.106 58.807 54.106 56.361V56.36ZM50.126 48.511L50.849 40.823C50.5902 40.7906 50.3298 40.7726 50.069 40.769C47.814 40.769 46.311 42.22 46.311 44.399C46.311 46.709 48.093 47.543 49.791 48.349L50.125 48.511H50.126ZM49.485 60.608L49.262 63H48.761L48.984 60.608C47.397 60.527 45.336 60.097 44.167 59.505L44 55.07H44.167C45.253 58.054 46.867 59.801 49.039 60.15L49.819 51.764C49.791 51.764 49.791 51.737 49.763 51.737L48.343 51.065C46.478 50.178 44.418 48.968 44.418 45.957C44.418 42.758 46.812 40.392 50.236 40.392C50.46 40.392 50.682 40.392 50.905 40.419L51.127 38H51.629L51.406 40.473C52.742 40.634 54.218 41.011 55.248 41.468V44.962H55.081C54.106 42.677 52.854 41.387 51.351 40.957L50.599 48.726L51.211 49.021C53.633 50.178 56 51.387 56 54.694C56 58.081 53.383 60.608 49.485 60.608V60.608Z"
                fill="white"
              />
            </g>
            <g id="text">
              <path
                id="Fill-09"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.32401 43.543L8.31001 43.54C8.17904 43.5161 8.05408 43.4665 7.94227 43.3942C7.83047 43.322 7.734 43.2283 7.6584 43.1187C7.5828 43.0092 7.52955 42.8857 7.50168 42.7555C7.47382 42.6254 7.47189 42.4909 7.49601 42.36C7.54261 42.0952 7.69245 41.8598 7.91261 41.7054C8.13276 41.5511 8.4052 41.4905 8.67001 41.537L8.68301 41.541C9.23301 41.64 9.59701 42.17 9.49801 42.72C9.47519 42.8512 9.42668 42.9767 9.35527 43.0891C9.28387 43.2016 9.19096 43.2988 9.08189 43.3753C8.97282 43.4517 8.84973 43.5059 8.71967 43.5347C8.58962 43.5635 8.45516 43.5663 8.32401 43.543"
                fill="white"
              />
              <path
                id="Fill-011"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.73505 37.45L9.72205 37.445C9.59608 37.402 9.47984 37.3346 9.37997 37.2466C9.2801 37.1586 9.19857 37.0518 9.14005 36.9322C9.08152 36.8127 9.04716 36.6828 9.03893 36.5499C9.03069 36.4171 9.04874 36.2839 9.09205 36.158C9.27205 35.629 9.84505 35.34 10.3751 35.52L10.3871 35.524C10.9171 35.704 11.1961 36.281 11.0171 36.811C10.8371 37.341 10.2651 37.629 9.73505 37.45Z"
                fill="white"
              />
              <path
                id="Fill-013"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.02 31.659L12.007 31.652C11.7688 31.528 11.5895 31.3145 11.5085 31.0584C11.4275 30.8023 11.4514 30.5245 11.575 30.286C11.6974 30.0466 11.9097 29.8654 12.1654 29.7824C12.4211 29.6993 12.6994 29.7211 12.939 29.843L12.95 29.85C13.449 30.106 13.64 30.719 13.385 31.216C13.2625 31.4555 13.05 31.6367 12.7941 31.7197C12.5382 31.8028 12.2599 31.7809 12.02 31.659"
                fill="white"
              />
              <path
                id="Fill-015"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.23 27.5581L16.102 26.5681C16.592 26.5201 16.959 26.3671 17.245 25.9761C17.48 25.6561 17.463 25.2971 17.177 25.0871L17.166 25.0801C16.853 24.8501 16.47 25.0011 16.123 25.4751L15.865 25.8261L15.229 25.5641L14.978 23.9671L13.868 25.4801L13.141 24.9471L15.051 22.3441L15.689 22.8111L15.905 24.4691C16.377 24.0091 17.028 23.6991 17.742 24.2241L17.754 24.2341C18.479 24.7641 18.627 25.6841 17.998 26.5441C17.488 27.2361 16.863 27.5141 16.23 27.5581"
                fill="white"
              />
              <path
                id="Fill-017"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.934 20.456L19.924 20.447C19.29 19.855 18.522 19.718 18.094 20.177C17.664 20.637 17.849 21.37 18.488 21.967L18.498 21.975C19.138 22.572 19.896 22.71 20.33 22.246C20.763 21.781 20.569 21.048 19.934 20.456ZM17.772 22.774L17.762 22.764C16.749 21.819 16.542 20.448 17.409 19.519C18.271 18.595 19.637 18.703 20.651 19.649L20.661 19.658C21.674 20.604 21.886 21.968 21.015 22.903C20.143 23.837 18.785 23.719 17.772 22.773"
                fill="white"
              />
              <path
                id="Fill-019"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.3621 18.741L22.9461 17.358L23.6021 18.108L22.0181 19.492L21.3621 18.741Z"
                fill="white"
              />
              <path
                id="Fill-021"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M26.476 16.759C27.181 16.266 27.323 15.458 26.837 14.764L26.829 14.754C26.344 14.059 25.528 13.906 24.823 14.4L24.157 14.867L25.811 17.227L26.476 16.759V16.759ZM22.751 14.692L24.279 13.622C25.509 12.76 26.949 13.009 27.721 14.11L27.729 14.122C28.501 15.223 28.251 16.674 27.021 17.537L25.495 18.607L22.751 14.692V14.692Z"
                fill="white"
              />
              <path
                id="Fill-023"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M31.56 12.517L30.29 11.426L30.428 13.096L31.56 12.517V12.517ZM29.297 10.514L30.159 10.074L34.171 13.431L33.191 13.93L32.316 13.175L30.516 14.093L30.614 15.245L29.659 15.733L29.297 10.514V10.514Z"
                fill="white"
              />
              <path
                id="Fill-025"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M35.648 10.898L32.954 8.77603L34.114 8.36803L35.827 9.80003L36.285 7.60503L37.412 7.20703L36.634 10.529L37.266 12.328L36.274 12.676L35.648 10.898Z"
                fill="white"
              />
              <path
                id="Fill-027"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M41.3101 6.24905L42.4321 6.08805L43.9651 7.91105L44.9201 5.73105L46.0431 5.56805L46.7241 10.3031L45.6891 10.4521L45.2451 7.36205L44.2031 9.57405L44.1761 9.57805L42.5701 7.76605L43.0121 10.8371L41.9901 10.9841L41.3101 6.24905Z"
                fill="white"
              />
              <path
                id="Fill-029"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M51.793 7.87303V7.85803C51.799 7.03803 51.203 6.35103 50.353 6.34403C49.508 6.33803 48.916 7.00403 48.909 7.82403V7.83803C48.903 8.65803 49.499 9.34603 50.347 9.35103C51.194 9.35803 51.787 8.69303 51.793 7.87303V7.87303ZM47.809 7.84303V7.82903C47.819 6.46903 48.899 5.36403 50.375 5.37403C51.852 5.38503 52.903 6.49303 52.894 7.85403L52.893 7.86703C52.883 9.22703 51.802 10.332 50.326 10.322C48.85 10.312 47.799 9.20303 47.809 7.84403"
                fill="white"
              />
              <path
                id="Fill-031"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M54.653 5.64905L55.611 5.79605L57.38 9.04505L57.826 6.13505L58.852 6.29405L58.126 11.019L57.243 10.883L55.416 7.52805L54.954 10.533L53.928 10.374L54.653 5.64905Z"
                fill="white"
              />
              <path
                id="Fill-033"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M60.708 6.72705L64.172 7.72405L63.912 8.62205L61.453 7.91505L61.186 8.84505L63.35 9.46905L63.09 10.3681L60.928 9.74405L60.648 10.7071L63.142 11.4261L62.882 12.3241L59.387 11.3171L60.708 6.72705Z"
                fill="white"
              />
              <path
                id="Fill-035"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M65.89 11.494L65.341 8.112L66.471 8.596L66.763 10.807L68.585 9.501L69.682 9.971L66.864 11.89L66.114 13.641L65.147 13.226L65.89 11.494Z"
                fill="white"
              />
              <path
                id="Fill-037"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M73.732 14.614C74.118 14.872 74.445 14.91 74.642 14.614L74.65 14.604C74.824 14.342 74.719 14.058 74.35 13.812L73.487 13.236L72.927 14.076L73.732 14.614V14.614ZM72.897 16.371C73.283 16.628 73.607 16.647 73.803 16.351L73.811 16.34C73.989 16.074 73.901 15.777 73.451 15.477L72.441 14.803L71.858 15.677L72.897 16.371V16.371ZM73.147 11.901L74.992 13.133C75.446 13.436 75.721 13.8 75.796 14.178C75.856 14.481 75.8 14.763 75.616 15.035L75.609 15.047C75.311 15.495 74.905 15.585 74.515 15.556C74.858 16.039 74.963 16.494 74.607 17.028L74.6 17.04C74.114 17.766 73.282 17.735 72.385 17.137L70.495 15.876L73.147 11.901V11.901Z"
                fill="white"
              />
              <path
                id="Fill-039"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M78.078 19.084L78.625 17.502L77.125 18.246L78.078 19.085V19.084ZM79.107 16.244L79.835 16.884L78.19 21.85L77.366 21.123L77.745 20.029L76.229 18.694L75.193 19.209L74.389 18.501L79.107 16.244V16.244Z"
                fill="white"
              />
              <path
                id="Fill-041"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80.444 20.781L80.454 20.772C81.482 19.882 82.995 19.927 83.957 21.037C84.547 21.719 84.674 22.324 84.635 22.947H83.612C83.624 22.448 83.532 22.029 83.22 21.668C82.691 21.058 81.805 21.058 81.185 21.596L81.175 21.604C80.555 22.142 80.41 23.017 80.947 23.637C81.305 24.05 81.689 24.16 82.194 24.221L82.121 25.17C81.401 25.142 80.795 24.944 80.191 24.247C79.269 23.183 79.405 21.681 80.444 20.781"
                fill="white"
              />
              <path
                id="Fill-043"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M86.106 23.841L86.684 24.718L84.942 25.868L87.752 26.338L88.449 27.396L85.688 26.888L84.51 30.1L83.815 29.047L84.699 26.69L83.915 26.545L82.696 27.348L82.118 26.471L86.106 23.841Z"
                fill="white"
              />
              <path
                id="Fill-045"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M88.142 32.001L88.155 31.996C88.4011 31.8882 88.68 31.8826 88.9303 31.9803C89.1806 32.078 89.3819 32.271 89.49 32.517C89.717 33.03 89.49 33.631 88.977 33.857L88.965 33.863C88.7183 33.9704 88.439 33.9757 88.1884 33.8777C87.9378 33.7797 87.7363 33.5863 87.628 33.34C87.403 32.829 87.628 32.228 88.142 32"
                fill="white"
              />
              <path
                id="Fill-047"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M90.368 37.806L90.381 37.803C90.5096 37.768 90.6439 37.7587 90.7761 37.7756C90.9084 37.7925 91.036 37.8352 91.1517 37.9014C91.2674 37.9676 91.3689 38.056 91.4505 38.1615C91.532 38.2669 91.592 38.3874 91.627 38.516C91.6627 38.6445 91.6728 38.7787 91.6567 38.911C91.6405 39.0433 91.5985 39.1712 91.5329 39.2873C91.4674 39.4033 91.3796 39.5054 91.2746 39.5875C91.1696 39.6697 91.0494 39.7303 90.921 39.766L90.909 39.77C90.6494 39.8402 90.3725 39.8045 90.1391 39.6708C89.9058 39.5372 89.7349 39.3164 89.664 39.057C89.5918 38.7979 89.6253 38.5207 89.7573 38.2863C89.8893 38.052 90.109 37.8796 90.368 37.807"
                fill="white"
              />
              <path
                id="Fill-049"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M91.721 43.884L91.735 43.882C92.0021 43.851 92.2706 43.927 92.4818 44.0934C92.693 44.2598 92.8297 44.5031 92.862 44.77C92.8954 45.0371 92.8213 45.3065 92.6561 45.519C92.4909 45.7314 92.248 45.8696 91.981 45.903L91.968 45.904C91.7008 45.9356 91.432 45.8598 91.2207 45.6933C91.0094 45.5268 90.8728 45.2832 90.841 45.016C90.8079 44.7493 90.8819 44.4803 91.0469 44.2681C91.2119 44.0559 91.4543 43.9177 91.721 43.884"
                fill="white"
              />
              <path
                id="Fill-051"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.637 69.514L12.649 69.5071C12.885 69.3782 13.1625 69.3482 13.4206 69.4235C13.6787 69.4989 13.8964 69.6735 14.026 69.9091C14.296 70.3991 14.124 71.017 13.633 71.288L13.621 71.295C13.131 71.565 12.515 71.382 12.245 70.893C12.1801 70.7767 12.1387 70.6487 12.1233 70.5164C12.1078 70.3841 12.1186 70.25 12.155 70.1218C12.1914 69.9937 12.2528 69.8739 12.3355 69.7695C12.4182 69.665 12.5206 69.5779 12.637 69.513"
                fill="white"
              />
              <path
                id="Fill-053"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.3451 75.392L16.3551 75.3831C16.5663 75.2168 16.8348 75.1411 17.1018 75.1726C17.3688 75.2041 17.6123 75.3402 17.7791 75.5511C17.9465 75.7612 18.0237 76.0292 17.9937 76.2962C17.9637 76.5631 17.829 76.8073 17.6191 76.9751L17.6091 76.9831C17.5046 77.0655 17.3849 77.1265 17.2569 77.1627C17.1288 77.1989 16.9949 77.2094 16.8628 77.1938C16.7306 77.1782 16.6028 77.1368 16.4867 77.0718C16.3706 77.0068 16.2685 76.9195 16.1861 76.8151C16.0188 76.6051 15.9417 76.3374 15.9715 76.0707C16.0013 75.804 16.1356 75.5599 16.3451 75.392"
                fill="white"
              />
              <path
                id="Fill-055"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.003 80.593L21.013 80.583C21.1939 80.3838 21.4464 80.2646 21.7151 80.2515C21.9838 80.2383 22.2467 80.3324 22.446 80.513C22.862 80.889 22.899 81.531 22.524 81.947L22.515 81.957C22.3339 82.1561 22.0812 82.2752 21.8123 82.2882C21.5435 82.3011 21.2805 82.2068 21.081 82.026C20.881 81.8462 20.7604 81.5943 20.7458 81.3257C20.7311 81.057 20.8237 80.7935 21.003 80.593"
                fill="white"
              />
              <path
                id="Fill-057"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M26.227 84.888L26.235 84.878C26.938 83.715 28.42 83.311 29.657 84.06C30.393 84.507 30.717 84.974 30.924 85.594L29.944 85.934C29.788 85.48 29.599 85.158 29.126 84.872C28.472 84.476 27.603 84.74 27.182 85.434L27.175 85.445C26.722 86.193 26.905 87.053 27.628 87.492C27.955 87.69 28.296 87.7861 28.623 87.7591L28.976 87.1761L28.072 86.627L28.542 85.851L30.317 86.9261L29.243 88.7011C28.5036 88.8278 27.7432 88.6822 27.103 88.291C25.831 87.521 25.496 86.097 26.227 84.888"
                fill="white"
              />
              <path
                id="Fill-059"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M31.838 88.464L32.884 85.941L33.857 86.344L32.821 88.842C32.521 89.562 32.728 90.082 33.321 90.329C33.915 90.575 34.423 90.364 34.713 89.663L35.763 87.133L36.733 87.536L35.701 90.029C35.146 91.365 34.123 91.711 32.938 91.22C31.75 90.728 31.3 89.765 31.838 88.464"
                fill="white"
              />
              <path
                id="Fill-061"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M40.4971 91.468L40.2461 89.813L39.2631 91.168L40.4971 91.468ZM40.0871 88.474L41.0291 88.704L41.8811 93.863L40.8131 93.603L40.6411 92.458L38.6791 91.981L38.0021 92.918L36.9611 92.665L40.0871 88.475V88.474Z"
                fill="white"
              />
              <path
                id="Fill-063"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M46.376 91.927C46.884 91.972 47.202 91.728 47.237 91.327L47.239 91.314C47.28 90.865 46.989 90.605 46.479 90.559L45.439 90.464L45.316 91.831L46.376 91.927V91.927ZM44.478 89.426L46.653 89.624C47.257 89.678 47.71 89.891 47.994 90.231C48.236 90.521 48.345 90.907 48.304 91.355L48.302 91.369C48.232 92.136 47.775 92.582 47.15 92.751L48.157 94.554L46.934 94.442L46.053 92.829H46.039L45.231 92.754L45.093 94.274L44.047 94.181L44.478 89.426V89.426Z"
                fill="white"
              />
              <path
                id="Fill-065"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M53.075 92.422L52.349 90.912L51.808 92.497L53.075 92.422V92.422ZM51.805 89.678L52.772 89.622L55.103 94.307L54.006 94.371L53.506 93.327L51.488 93.447L51.115 94.542L50.045 94.607L51.805 89.678Z"
                fill="white"
              />
              <path
                id="Fill-067"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M56.2991 89.302L57.2471 89.098L60.0581 91.504L59.4381 88.626L60.4531 88.406L61.4621 93.083L60.5861 93.27L57.6811 90.786L58.3211 93.759L57.3071 93.978L56.2991 89.302Z"
                fill="white"
              />
              <path
                id="Fill-069"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M63.66 88.369L62.294 88.872L61.96 87.962L65.674 86.593L66.01 87.503L64.645 88.006L65.963 91.581L64.976 91.943L63.66 88.369Z"
                fill="white"
              />
              <path
                id="Fill-071"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M67.02 85.964L70.216 84.286L70.651 85.115L68.381 86.306L68.833 87.166L70.831 86.116L71.266 86.946L69.269 87.994L69.736 88.884L72.035 87.676L72.471 88.505L69.246 90.2L67.02 85.964Z"
                fill="white"
              />
              <path
                id="Fill-073"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M71.634 83.4L74.576 81.314L75.119 82.077L73.029 83.559L73.591 84.35L75.428 83.046L75.97 83.809L74.13 85.114L74.711 85.934L76.831 84.431L77.371 85.195L74.401 87.301L71.634 83.4Z"
                fill="white"
              />
              <path
                id="Fill-075"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M79.484 80.128L79.475 80.118C79.3799 80.025 79.3039 79.9141 79.2516 79.7918C79.1993 79.6694 79.1716 79.5379 79.1701 79.4048C79.1686 79.2717 79.1934 79.1397 79.243 79.0162C79.2925 78.8927 79.3659 78.7801 79.459 78.685C79.6455 78.4917 79.9011 78.3804 80.1696 78.3755C80.4382 78.3707 80.6977 78.4726 80.891 78.659L80.901 78.669C81.303 79.059 81.307 79.7 80.917 80.102C80.7304 80.2953 80.4746 80.4067 80.2059 80.4116C79.9372 80.4164 79.6776 80.3144 79.484 80.128Z"
                fill="white"
              />
              <path
                id="Fill-077"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M84.028 74.869L84.017 74.86C83.557 74.542 83.447 73.91 83.764 73.449C84.083 72.989 84.714 72.869 85.175 73.188L85.185 73.195C85.646 73.515 85.756 74.147 85.437 74.607C85.119 75.067 84.488 75.187 84.028 74.869"
                fill="white"
              />
              <path
                id="Fill-079"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M87.644 68.958L87.632 68.952C87.3895 68.8358 87.203 68.6279 87.1135 68.3743C87.0241 68.1206 87.039 67.8417 87.155 67.599C87.395 67.092 87.999 66.874 88.505 67.113L88.516 67.118C89.022 67.358 89.233 67.966 88.993 68.471C88.753 68.976 88.151 69.197 87.644 68.958"
                fill="white"
              />
            </g>
          </g>
          <g id="arrrows" ref={arrowRef}>
            <path
              id="Path_00"
              d="M50.347 27.717C54.324 27.717 58.307 28.828 61.863 30.932C64.3523 32.4056 66.5633 34.3051 68.395 36.544L61.721 36.327L61.664 38.043L70.101 38.317C70.3302 38.3259 70.5536 38.2436 70.7222 38.0879C70.8907 37.9323 70.9906 37.7162 71 37.487V37.431L70.722 29.114L68.982 29.17L69.169 34.778C67.3251 32.6795 65.1619 30.8848 62.759 29.46C58.932 27.196 54.639 26 50.347 26C43.488 26 37.166 28.787 32.544 33.85C28.446 38.337 26 44.374 26 50H27.741C27.741 44.788 30.021 39.18 33.838 34.998C38.125 30.302 43.988 27.717 50.347 27.717V27.717Z"
              fill="#6C4BC2"
            />
            <path
              id="Path_02"
              d="M66.162 65.002C61.875 69.698 56.012 72.283 49.653 72.283C45.676 72.283 41.694 71.172 38.138 69.068C35.6488 67.5943 33.4379 65.6947 31.606 63.456L38.279 63.673L38.337 61.957L29.899 61.683C29.7806 61.6782 29.6626 61.6977 29.5521 61.7404C29.4416 61.7831 29.3411 61.8481 29.2568 61.9312C29.1725 62.0144 29.1062 62.1141 29.062 62.2239C29.0178 62.3338 28.9967 62.4516 29 62.57L29.279 70.888L31.019 70.831L30.832 65.224C32.6762 67.3219 34.8394 69.1162 37.242 70.541C41.069 72.804 45.36 74 49.653 74C56.512 74 62.834 71.213 67.456 66.15C71.554 61.663 74 55.626 74 50H72.259C72.259 55.212 69.979 60.82 66.162 65.002Z"
              fill="#6C4BC2"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

export const FreeShippingBadge = ({ heart1Ref, heart2Ref, heart3Ref }) => {
  return (
    <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="100" height="100" />
      <g id="free-shipping-badge">
        <g id="positive-elements_0">
          <g id="Group-6">
            <g id="Group-03">
              <mask
                id="mask0_1028_2980"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="100"
                height="100"
              >
                <g id="mask-02">
                  <path id="Vector3" d="M0 0H100V100H0V0Z" fill="white" />
                </g>
              </mask>
              <g mask="url(#mask0_1028_2980)">
                <path
                  id="Fill-001"
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M50 0.639C22.782 0.639 0.639 22.782 0.639 49.999C0.639 77.217 22.782 99.361 49.999 99.361C77.217 99.361 99.361 77.217 99.361 50C99.36 22.782 77.217 0.639 50 0.639ZM50 100C22.43 100 0 77.57 0 50C0 22.43 22.43 0 50 0C77.57 0 100 22.43 100 50C100 77.57 77.57 100 50 100Z"
                  fill="white"
                />
              </g>
            </g>
            <path
              id="Fill-004"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M50 14.243C30.283 14.243 14.243 30.283 14.243 50C14.243 69.717 30.283 85.758 50 85.758C69.716 85.758 85.756 69.718 85.756 50C85.756 30.283 69.716 14.243 50 14.243V14.243ZM50 86.397C29.93 86.397 13.604 70.069 13.604 50C13.604 29.93 29.931 13.604 50 13.604C70.068 13.604 86.395 29.931 86.395 50C86.395 70.069 70.068 86.397 50 86.397"
              fill="white"
            />
          </g>
          <g id="Group-55">
            <path
              id="Fill-007"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M25.008 16.134L25 16.124C24.9237 16.0149 24.8698 15.8918 24.8413 15.7619C24.8127 15.6319 24.8101 15.4975 24.8336 15.3665C24.8571 15.2355 24.9063 15.1104 24.9782 14.9985C25.0502 14.8865 25.1436 14.7898 25.253 14.714C25.3615 14.6374 25.4841 14.5829 25.6138 14.5536C25.7434 14.5244 25.8776 14.521 26.0086 14.5437C26.1395 14.5663 26.2647 14.6146 26.377 14.6857C26.4893 14.7568 26.5865 14.8493 26.663 14.958L26.671 14.969C26.991 15.427 26.875 16.057 26.418 16.377C26.3095 16.4539 26.1869 16.5086 26.0573 16.538C25.9277 16.5673 25.7935 16.5708 25.6625 16.5483C25.5315 16.5257 25.4063 16.4775 25.2939 16.4064C25.1816 16.3353 25.0844 16.2428 25.008 16.134"
              fill="white"
            />
            <path
              id="Fill-009"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M30.273 12.822L30.267 12.809C30.2081 12.6901 30.1731 12.5608 30.1642 12.4284C30.1552 12.2959 30.1725 12.1631 30.2149 12.0373C30.2573 11.9116 30.3242 11.7954 30.4115 11.6955C30.4989 11.5956 30.6051 11.5139 30.724 11.455C30.8426 11.395 30.9719 11.3589 31.1045 11.3489C31.237 11.3389 31.3703 11.3552 31.4965 11.3968C31.6228 11.4385 31.7396 11.5046 31.8402 11.5915C31.9409 11.6783 32.0234 11.7842 32.083 11.903L32.089 11.916C32.339 12.414 32.13 13.02 31.631 13.27C31.5125 13.3299 31.3833 13.3659 31.2508 13.3758C31.1183 13.3857 30.9852 13.3693 30.8591 13.3277C30.7329 13.2861 30.6162 13.22 30.5157 13.1333C30.4151 13.0465 30.3327 12.9407 30.273 12.822Z"
              fill="white"
            />
            <path
              id="Fill-0011"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M35.969 10.325L35.965 10.312C35.791 9.78104 36.087 9.21204 36.617 9.03804C36.872 8.95431 37.1498 8.97521 37.3894 9.09614C37.629 9.21707 37.8109 9.42816 37.895 9.68304L37.899 9.69705C38.072 10.227 37.778 10.797 37.246 10.97C36.9911 11.0537 36.7134 11.0328 36.474 10.9119C36.2345 10.7909 36.0529 10.5799 35.969 10.325"
              fill="white"
            />
            <path
              id="Fill-0013"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M41.5179 6.34302L45.1039 5.78302L45.2519 6.72502L42.7019 7.12302L42.8579 8.12602L45.1039 7.77502L45.2529 8.71702L43.0039 9.06702L43.2889 10.891L42.2529 11.053L41.5179 6.34302Z"
              fill="white"
            />
            <path
              id="Fill-0015"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M48.8659 7.88802C49.3759 7.87102 49.6599 7.58802 49.6479 7.18802L49.6469 7.17402C49.6319 6.72402 49.3119 6.50202 48.8009 6.51902L47.7589 6.55202L47.8029 7.92102L48.8659 7.88802ZM46.6799 5.63802L48.8599 5.57002C49.4649 5.55002 49.9409 5.70502 50.2649 6.00802C50.5389 6.26502 50.6929 6.63502 50.7079 7.08502V7.09802C50.7319 7.86802 50.3339 8.36502 49.7339 8.61002L50.9539 10.276L49.7279 10.315L48.6559 8.82202H48.6439L47.8319 8.84702L47.8819 10.373L46.8319 10.407L46.6809 5.63802H46.6799Z"
              fill="white"
            />
            <path
              id="Fill-0017"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M52.3319 5.58203L55.9129 5.90503L55.8289 6.83503L53.2849 6.60503L53.1989 7.56803L55.4369 7.77003L55.3529 8.70003L53.1159 8.49803L53.0239 9.49603L55.6029 9.72603L55.5199 10.656L51.9039 10.33L52.3319 5.58203Z"
              fill="white"
            />
            <path
              id="Fill-0019"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M57.6119 6.16803L61.1339 6.92103L60.9379 7.83403L58.4379 7.30003L58.2349 8.24603L60.4349 8.71603L60.2419 9.63003L58.0399 9.16003L57.8319 10.14L60.3649 10.681L60.1709 11.594L56.6169 10.835L57.6119 6.16803Z"
              fill="white"
            />
            <path
              id="Fill-0021"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M64.3629 10.438L64.3679 10.425C64.5729 9.90501 65.1609 9.65201 65.6819 9.85701C66.2019 10.06 66.4629 10.645 66.2599 11.165L66.2549 11.178C66.0499 11.698 65.4619 11.951 64.9419 11.748C64.8178 11.7001 64.7044 11.6282 64.6081 11.5364C64.5118 11.4446 64.4346 11.3347 64.3808 11.2131C64.327 11.0914 64.2978 10.9603 64.2947 10.8273C64.2916 10.6943 64.3148 10.562 64.3629 10.438"
              fill="white"
            />
            <path
              id="Fill-0023"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M70.035 12.991L70.042 12.979C70.1766 12.7468 70.3979 12.5776 70.6572 12.5086C70.9166 12.4396 71.1928 12.4764 71.425 12.611C71.909 12.888 72.081 13.506 71.802 13.991L71.796 14.002C71.7295 14.1173 71.6409 14.2183 71.5353 14.2993C71.4298 14.3803 71.3092 14.4397 71.1807 14.474C71.0521 14.5084 70.9181 14.5171 70.7862 14.4996C70.6542 14.4821 70.5271 14.4387 70.412 14.372C70.179 14.2387 70.0084 14.0184 69.9377 13.7595C69.8671 13.5006 69.902 13.2242 70.035 12.991"
              fill="white"
            />
            <path
              id="Fill-0025"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M75.273 16.358L75.281 16.346C75.3635 16.2421 75.4658 16.1554 75.5818 16.091C75.6979 16.0266 75.8255 15.9857 75.9574 15.9707C76.0893 15.9556 76.2228 15.9667 76.3504 16.0033C76.478 16.0399 76.5971 16.1013 76.701 16.184C77.139 16.53 77.219 17.166 76.873 17.604L76.864 17.616C76.6965 17.8253 76.4529 17.9596 76.1865 17.9896C75.9202 18.0196 75.6528 17.9428 75.443 17.776C75.2326 17.6102 75.0966 17.3677 75.0647 17.1017C75.0328 16.8357 75.1077 16.5679 75.273 16.357"
              fill="white"
            />
            <path
              id="Fill-0027"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M16.208 75.055L16.218 75.045C16.4307 74.8814 16.6996 74.8088 16.9658 74.8431C17.2319 74.8774 17.4737 75.0158 17.638 75.228C17.981 75.668 17.908 76.306 17.466 76.648L17.456 76.658C17.3507 76.7393 17.2304 76.7989 17.102 76.8336C16.9737 76.8683 16.8397 76.8774 16.7078 76.8603C16.5759 76.8432 16.4487 76.8003 16.3334 76.734C16.2182 76.6678 16.1171 76.5794 16.036 76.474C15.9538 76.3696 15.8931 76.2499 15.8573 76.122C15.8215 75.994 15.8113 75.8603 15.8273 75.7283C15.8433 75.5964 15.8851 75.469 15.9504 75.3533C16.0158 75.2376 16.1033 75.1359 16.208 75.054"
              fill="white"
            />
            <path
              id="Fill-0029"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M20.801 80.276L20.809 80.266C20.991 80.0689 21.2439 79.9521 21.512 79.9413C21.7801 79.9304 22.0415 80.0263 22.239 80.208C22.651 80.585 22.684 81.225 22.307 81.638L22.297 81.648C22.115 81.8453 21.8621 81.9623 21.594 81.9732C21.3258 81.984 21.0643 81.8879 20.867 81.706C20.7687 81.6165 20.6891 81.5084 20.6326 81.3881C20.5761 81.2678 20.5438 81.1375 20.5377 81.0047C20.5316 80.8719 20.5517 80.7392 20.5968 80.6142C20.642 80.4891 20.7114 80.3742 20.801 80.276"
              fill="white"
            />
            <path
              id="Fill-0031"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M26.193 84.656L26.201 84.645C26.2751 84.5349 26.3702 84.4405 26.4809 84.3672C26.5916 84.2938 26.7156 84.243 26.8459 84.2177C26.9762 84.1923 27.1102 84.1929 27.2403 84.2194C27.3704 84.2459 27.494 84.2978 27.604 84.372C28.069 84.682 28.198 85.311 27.886 85.774L27.878 85.785C27.8038 85.8952 27.7087 85.9896 27.5981 86.0629C27.4874 86.1362 27.3634 86.187 27.2331 86.2124C27.1028 86.2377 26.9687 86.2372 26.8387 86.2107C26.7086 86.1842 26.585 86.1323 26.475 86.058C26.3644 85.9845 26.2694 85.8899 26.1953 85.7797C26.1213 85.6694 26.0697 85.5457 26.0435 85.4155C26.0173 85.2853 26.0171 85.1512 26.0427 85.0209C26.0684 84.8906 26.1194 84.7666 26.193 84.656"
              fill="white"
            />
            <path
              id="Fill-0033"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M31.153 89.523L32.015 89.083C32.271 89.576 32.597 89.96 33.099 90.174C33.494 90.342 33.799 90.287 33.909 90.029L33.913 90.017C34.018 89.772 33.92 89.582 33.267 89.082C32.479 88.48 32.012 87.992 32.383 87.122L32.389 87.108C32.729 86.311 33.593 86.058 34.489 86.439C35.129 86.712 35.589 87.144 35.883 87.692L35.071 88.205C34.796 87.77 34.483 87.445 34.115 87.286C33.743 87.128 33.477 87.215 33.387 87.43L33.381 87.441C33.258 87.731 33.406 87.905 34.081 88.421C34.874 89.033 35.24 89.567 34.913 90.331L34.908 90.345C34.538 91.215 33.663 91.422 32.716 91.019C32.0291 90.7289 31.4729 90.1965 31.153 89.523"
              fill="white"
            />
            <path
              id="Fill-0035"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M37.776 87.803L38.789 88.074L38.298 89.896L40.166 90.398L40.656 88.577L41.668 88.849L40.43 93.453L39.417 93.18L39.914 91.333L38.046 90.83L37.549 92.678L36.538 92.405L37.776 87.803Z"
              fill="white"
            />
            <path
              id="Fill-0037"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M43.4639 89.138L44.5019 89.296L43.7869 94.01L42.7489 93.852L43.4639 89.138Z"
              fill="white"
            />
            <path
              id="Fill-0039"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M48.048 92.033C48.571 92.059 48.893 91.762 48.914 91.353V91.34C48.937 90.87 48.624 90.602 48.099 90.576L47.289 90.536L47.217 91.992L48.047 92.032L48.048 92.033ZM46.29 89.537L48.235 89.635C49.372 89.692 50.025 90.398 49.976 91.373V91.385C49.92 92.487 49.034 93.016 47.967 92.963L47.171 92.924L47.1 94.352L46.053 94.3L46.29 89.537V89.537Z"
              fill="white"
            />
            <path
              id="Fill-0041"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M53.615 91.914C54.139 91.869 54.418 91.532 54.385 91.124L54.383 91.111C54.344 90.642 53.999 90.417 53.475 90.461L52.665 90.528L52.785 91.982L53.615 91.914V91.914ZM51.541 89.668L53.485 89.508C54.621 89.413 55.363 90.03 55.443 91.002V91.015C55.535 92.116 54.726 92.757 53.658 92.846L52.863 92.912L52.982 94.34L51.935 94.426L51.541 89.668V89.668Z"
              fill="white"
            />
            <path
              id="Fill-0043"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M56.735 89.094L57.765 88.903L58.638 93.59L57.606 93.782L56.735 89.094Z"
              fill="white"
            />
            <path
              id="Fill-0045"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M59.5609 88.555L60.4859 88.274L63.4779 90.434L62.6239 87.624L63.6159 87.324L65.0009 91.888L64.1459 92.147L61.0559 89.917L61.9359 92.817L60.9459 93.117L59.5609 88.555Z"
              fill="white"
            />
            <path
              id="Fill-0047"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M66.259 88.865L66.253 88.852C65.663 87.632 66.13 86.172 67.433 85.542C68.204 85.168 68.772 85.152 69.404 85.315L69.156 86.321C68.691 86.205 68.319 86.187 67.823 86.428C67.134 86.76 66.883 87.633 67.235 88.362L67.241 88.375C67.622 89.161 68.441 89.476 69.201 89.108C69.544 88.942 69.811 88.708 69.967 88.42L69.671 87.806L68.72 88.267L68.324 87.45L70.19 86.548L71.092 88.414C70.7957 89.1013 70.2608 89.6583 69.586 89.982C68.249 90.629 66.873 90.135 66.259 88.865"
              fill="white"
            />
            <path
              id="Fill-0049"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M74.3789 84.284L74.3699 84.274C74.2105 84.0584 74.1431 83.7884 74.1825 83.5231C74.2219 83.2579 74.3648 83.019 74.5799 82.859C74.6862 82.7792 74.8071 82.721 74.9358 82.6879C75.0645 82.6548 75.1985 82.6474 75.3301 82.666C75.4616 82.6847 75.5883 82.7291 75.7027 82.7967C75.8171 82.8643 75.9171 82.9538 75.9969 83.06L76.0039 83.07C76.0831 83.1766 76.1405 83.2978 76.1728 83.4265C76.205 83.5553 76.2116 83.6892 76.1921 83.8205C76.1726 83.9519 76.1274 84.0781 76.0591 84.1919C75.9908 84.3058 75.9007 84.405 75.7939 84.484C75.6879 84.5638 75.5672 84.622 75.4387 84.6552C75.3102 84.6883 75.1764 84.6958 75.045 84.6773C74.9136 84.6587 74.7871 84.6144 74.6728 84.5469C74.5585 84.4794 74.4587 84.3901 74.3789 84.284"
              fill="white"
            />
            <path
              id="Fill-0051"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M79.681 79.808L79.671 79.799C79.4776 79.6132 79.366 79.3582 79.3606 79.09C79.3551 78.8219 79.4563 78.5626 79.642 78.369C79.827 78.1742 80.0818 78.0609 80.3503 78.054C80.6188 78.047 80.8791 78.1471 81.074 78.332L81.083 78.34C81.487 78.727 81.497 79.367 81.111 79.77C81.0196 79.8665 80.9101 79.944 80.7888 79.9981C80.6675 80.0522 80.5366 80.0819 80.4038 80.0854C80.271 80.0889 80.1388 80.0663 80.0148 80.0187C79.8908 79.9711 79.7773 79.8995 79.681 79.808"
              fill="white"
            />
            <path
              id="Fill-0053"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M84.175 74.512L84.163 74.503C84.0536 74.4279 83.9601 74.3319 83.8879 74.2206C83.8156 74.1093 83.766 73.9849 83.7418 73.8544C83.7177 73.7239 83.7195 73.59 83.7471 73.4602C83.7748 73.3304 83.8277 73.2073 83.903 73.098C83.9772 72.988 84.0724 72.8936 84.1831 72.8204C84.2937 72.7472 84.4178 72.6965 84.5481 72.6712C84.6784 72.646 84.8124 72.6466 84.9424 72.6732C85.0725 72.6998 85.196 72.7517 85.306 72.826L85.317 72.834C85.779 73.148 85.893 73.779 85.579 74.241C85.4284 74.4628 85.196 74.6158 84.9328 74.6664C84.6696 74.717 84.397 74.6611 84.175 74.511"
              fill="white"
            />
          </g>
        </g>
        <g id="box">
          <path
            id="Path"
            d="M62.464 53.418H36.536V50.362L49.5 48.735L62.464 50.362V53.418Z"
            fill="#37246B"
          />
          <path id="Path_2" d="M62.464 53.418H49.5V48.735L62.464 48.801V53.418Z" fill="#1F1244" />
          <path
            id="Path_3"
            d="M36.536 56.418V67.658L49.5 70L62.464 67.658V56.418L49.5 53.418L36.536 56.418Z"
            fill="#503A8B"
          />
          <path
            id="Path_4"
            d="M62.464 57.433L49.5 53.418V70L62.464 67.658V57.433Z"
            fill="#1F1244"
          />
          <path
            id="Path_5"
            d="M45.964 59.273L33 56.93L36.536 51.075L49.5 53.418L45.964 59.273Z"
            fill="#674CAD"
          />
          <path
            id="Path_6"
            d="M45.964 42.88L33 45.222L36.536 51.076L49.5 48.735L45.964 42.88Z"
            fill="#6147A7"
          />
          <g id="Group">
            <path
              id="Path_7"
              d="M53.036 42.88L66 45.222L62.464 51.076L49.5 48.735L53.036 42.88Z"
              fill="#6C4BC2"
            />
            <path
              id="Path_8"
              d="M53.036 59.273L66 56.93L62.464 51.075L49.5 53.418L53.036 59.273Z"
              fill="#5E44A4"
            />
          </g>
        </g>
        <g id="heart-1" ref={heart1Ref}>
          <path
            id="Path_9"
            d="M53.181 31.023C52.6913 30.5378 52.0298 30.2656 51.3405 30.2656C50.6512 30.2656 49.9897 30.5378 49.5 31.023L49.295 31.04L49.01 30.757C48.5203 30.2721 47.8591 30.0001 47.17 30.0001C46.4809 30.0001 45.8196 30.2721 45.33 30.757C45.0883 30.9963 44.8964 31.2812 44.7655 31.5951C44.6346 31.9091 44.5671 32.2459 44.5671 32.586C44.5671 32.9261 44.6346 33.2629 44.7655 33.5769C44.8964 33.8908 45.0883 34.1757 45.33 34.415L49.294 38.06L53.079 34.238C54.095 33.228 54.197 32.033 53.18 31.023H53.181Z"
            fill="white"
          />
          <path
            id="Path_10"
            d="M53.26 30.757C52.7704 30.2718 52.1089 29.9996 51.4195 29.9996C50.7302 29.9996 50.0687 30.2718 49.579 30.757L49.295 31.04V38.06L53.26 34.415C53.5017 34.1757 53.6936 33.8908 53.8245 33.5769C53.9555 33.2629 54.0229 32.9262 54.0229 32.586C54.0229 32.2459 53.9555 31.9091 53.8245 31.5951C53.6936 31.2812 53.5017 30.9963 53.26 30.757V30.757Z"
            fill="#D1CFD3"
          />
        </g>
        <g id="heart-2" ref={heart2Ref}>
          <path
            id="Path_11"
            d="M53.181 31.023C52.6913 30.5378 52.0298 30.2656 51.3405 30.2656C50.6512 30.2656 49.9897 30.5378 49.5 31.023L49.295 31.04L49.01 30.757C48.5203 30.2721 47.8591 30.0001 47.17 30.0001C46.4809 30.0001 45.8196 30.2721 45.33 30.757C45.0883 30.9963 44.8964 31.2812 44.7655 31.5951C44.6346 31.9091 44.5671 32.2459 44.5671 32.586C44.5671 32.9261 44.6346 33.2629 44.7655 33.5769C44.8964 33.8908 45.0883 34.1757 45.33 34.415L49.294 38.06L53.079 34.238C54.095 33.228 54.197 32.033 53.18 31.023H53.181Z"
            fill="white"
          />
          <path
            id="Path_12"
            d="M53.26 30.757C52.7704 30.2718 52.1089 29.9996 51.4195 29.9996C50.7302 29.9996 50.0687 30.2718 49.579 30.757L49.295 31.04V38.06L53.26 34.415C53.5017 34.1757 53.6936 33.8908 53.8245 33.5769C53.9555 33.2629 54.0229 32.9262 54.0229 32.586C54.0229 32.2459 53.9555 31.9091 53.8245 31.5951C53.6936 31.2812 53.5017 30.9963 53.26 30.757V30.757Z"
            fill="#D1CFD3"
          />
        </g>
        <g id="heart-3" ref={heart3Ref}>
          <path
            id="Path_13"
            d="M53.181 31.023C52.6913 30.5378 52.0298 30.2656 51.3405 30.2656C50.6512 30.2656 49.9897 30.5378 49.5 31.023L49.295 31.04L49.01 30.757C48.5203 30.2721 47.8591 30.0001 47.17 30.0001C46.4809 30.0001 45.8196 30.2721 45.33 30.757C45.0883 30.9963 44.8964 31.2812 44.7655 31.5951C44.6346 31.9091 44.5671 32.2459 44.5671 32.586C44.5671 32.9261 44.6346 33.2629 44.7655 33.5769C44.8964 33.8908 45.0883 34.1757 45.33 34.415L49.294 38.06L53.079 34.238C54.095 33.228 54.197 32.033 53.18 31.023H53.181Z"
            fill="white"
          />
          <path
            id="Path_14"
            d="M53.26 30.757C52.7704 30.2718 52.1089 29.9996 51.4195 29.9996C50.7302 29.9996 50.0687 30.2718 49.579 30.757L49.295 31.04V38.06L53.26 34.415C53.5017 34.1757 53.6936 33.8908 53.8245 33.5769C53.9555 33.2629 54.0229 32.9262 54.0229 32.586C54.0229 32.2459 53.9555 31.9091 53.8245 31.5951C53.6936 31.2812 53.5017 30.9963 53.26 30.757V30.757Z"
            fill="#D1CFD3"
          />
        </g>
      </g>
    </svg>
  )
}
